import {authHeader} from '../_helpers';
import {handleResponse} from '../_helpers';


export const stateService = {
    getStateCollection
};


function getStateCollection() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(process.env.VUE_APP_API_SERVER+`/api/states?pagination=false`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}